module.exports = __webpack_public_path__ + "static/status_refund_succ.3b69fb31.png";